<template>
    <div class="cl_tabs">
        <ul class="cl_tabs_wrapper" :style="{ height }">
            <li
                class="tabs_item"
                :class="[styleType]"
                :style="{ width: itemW, minWidth: minWidth }"
                v-for="(item, index) in options"
                :key="index"
                @click="onTabClick(item)"
            >
                <div class="tabs_item_con" :style="currentStyle(item.key)" v-if="item.no$t" @dblclick.stop="showEditInput(item, index)">
                    <div v-if="item.isEdit && canEditTab" ref="tabItem" contenteditable="true" class="tab_item_input" @blur="handleEditTab($event, item)" @keydown.enter="handleEditTab($event, item)">{{item.title}}</div>
                    <span v-else class="tabs_item_con_text" :class="{'SysFontM': active === item.key}">{{item.title}}</span>
                    <cl-svg-icon v-if="canDelTab" class="tabs_item_icon" icon-class="close" style="color: insert;" @click.native.stop="$emit('handle-tab-close', item)"></cl-svg-icon>
                </div>
                <div class="tabs_item_con" :style="currentStyle(item.key)" v-else @dblclick.stop="showEditInput(item, index)">
                    <div v-if="item.isEdit && canEditTab" ref="tabItem" contenteditable="true" class="tab_item_input" @blur="handleEditTab($event, item)" @keydown.enter="handleEditTab($event, item)">{{item.title}}</div>
                    <span v-else class="tabs_item_con_text" :class="{'SysFontM': active === item.key}">{{$t(item.title)}}</span>
                    <cl-svg-icon v-if="canDelTab" class="tabs_item_icon" icon-class="close" style="color: insert;" @click.native.stop="$emit('handle-tab-close', item)"></cl-svg-icon>
                </div>
                <div class="tabs_icon" v-if="styleType === 'whiteCard'">
                    <cl-svg-icon
                        iconClass="tab_right"
                        :height="parseInt(height)"
                        :width="14"
                        :style="currentStyle(item.key, 'color')"
                    ></cl-svg-icon>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
/**
 * ComponentName: tab切换UI
 * Created Date:2022/4/21
 * Author: shishuo·zhang
 * Modify: haogang·du 2022/4/28 | dongyu·zhu 2022/5/11
 * 组件说明：
 *  @param {array} options 传入的tab数组 
 *  @param {array} activeTab 高亮的tab项
 * eg:
 *     <cl-tabs></cl-tabs>
 */
export default {
    name: 'cl-tabs',
    props: {
        options: {
            type: Array,
            default: () => []
        },
        activeTab: {
            type: [String, Number],
            default: ''
        },
        // 组件高度 默认为48px
        height: {
            type: String,
            default: '48px'
        },
        // 组件内item宽度 默认为160px
        itemW: {
            type: String,
            default: '154px'
        },
        minWidth: {
            type: String,
            default: 'none'
        },
        // 默认的tab背景颜色
        defaultBgColor: {
            type: String,
            default: '#f3f3f6'
        },
        // 高亮的tab背景颜色
        activeBgColor: {
            type: String,
            default: '#f3f3f6'
        },
        // 默认的tab文字颜色
        defaultColor: {
            type: String,
            default: '#B0B0C8'
        },
        // 高亮的tab文字颜色
        activeColor: {
            type: String,
            default: '#3A3A3A'
        },
        // tab文字是否可以被修改
        canEditTab: {
            type: Boolean,
            default: false,
        },
        // tab是否可以被删除
        canDelTab: {
            type: Boolean,
            default: false,
        },
        // 样式类型 whiteCard 白色带斜边样式|blueCard 新样式-蓝色按钮式|
        styleType: {
            type: String,
            default: 'whiteCard'
        }
    },
    data () {
        return {
            description: 'tabs',
            active: this.activeTab,
        }
    },

    watch: {
        activeTab: {
            immediate: true,
            handler (val) {
                this.active = val
            }
        }
    },

    methods: {
        // 当前样式
        currentStyle (key, type) {
            let background = this.active === key ? this.activeBgColor : this.defaultBgColor;
            let color = this.active === key ? this.activeColor : this.defaultColor;
            let style = {
                background,
                color,
                lineHeight: this.height
            };
            if (type === 'color') {
                style = { color: background };
            }
            return style;
        },

        onTabClick (item) {
            if (this.active === item.key) return;
            if (this.canEditTab && item.isEdit) {
                return;
            }
            this.active = item.key;
            this.$emit('tab-click', item.key, item);
        },

        // 显示input框修改tab名称
        showEditInput(item) {
            if (!this.canEditTab) {
                return;
            }
            this.options.forEach(item => item.isEdit = false);
            this.$set(item, 'isEdit', true);
            this.$nextTick(() => {
                const dom = this.$refs.tabItem[0];
                dom.focus();
                const selection = window.getSelection();
                selection.removeAllRanges();
                const range = document.createRange();
                range.selectNodeContents(dom);
                selection.addRange(range);
            })
        },

        // blur事件emit最新的值供父组件更新
        handleEditTab(event, item) {
            item.title = event.target.innerText;
            this.$set(item, 'isEdit', false);
            this.$emit('handle-edit-tab', item)
        }
    },

    model: {
        prop: 'activeTab',
        event: 'tab-click'
    }

}
</script>

<style lang="scss" scoped>
.cl_tabs {
    width: 100%;
    overflow: auto hidden;
}

.cl_tabs_wrapper {
    display: flex;
    width: 100%;
    .tabs_item.whiteCard {
        font-size: $base-fontSize-16;
        cursor: pointer;
        position: relative;
        width: auto;
        margin-right: 14px;
        .tabs_item_con {
            display: flex;
            align-items: center;
            height: 100%;
            border-top-left-radius: 6px;
            width: auto;
            text-align: center;
            padding-left: 14px;
            justify-content: center;
            box-sizing: border-box;
            .tabs_item_con_text {
                display: inline-block;
                white-space: nowrap;
            }
            .tabs_item_icon {
                border-radius: 50%;
                margin-left: 10px;
                &:hover{
                    color: #fff;
                    background: rgba(0, 0, 0, 0.16);
                }
            }
            .tab_item_input {
                display: inline-block;
                width: auto;
                white-space: nowrap;
                min-width: 3em;
                height: 30px;
                line-height: 30px;
                padding: 0 10px;
                background: #fff;
            }
        }
        .tabs_icon {
            position: absolute;
            right: -13px;
            top: 0;
        }
    }
    
    .tabs_item.blueCard {
        width: auto!important;
        .tabs_item_con {
            height: 38px;
            padding: 0 20px;
            box-sizing: border-box;
            border-radius: 4px;
            cursor: pointer;
            font-size: $base-fontSize-14;
            white-space: nowrap;
        }
    }
}
</style>
